var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopEventImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 444,
    viewBox: "0 0 186 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.929 356.033C189.178 356.051 186.62 358.249 186.439 361.821C186.251 365.519 188.516 368.013 192.44 368.294C195.864 368.539 198.602 365.609 198.667 362.469C198.98 359.276 196.1 356.018 192.929 356.033Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.839 353.37C175.877 352.954 173.12 355.927 173.021 358.87C172.911 362.158 175.004 364.724 178.62 364.997C181.766 365.233 184.663 363.09 184.641 359.598C184.784 356.25 182.652 353.666 179.839 353.37Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.556 339.66C179.427 339.448 176.48 342.014 176.259 345.141C176.041 348.223 178.66 351.142 181.833 351.354C184.887 351.558 187.741 349.034 187.949 345.943C188.167 342.73 185.715 339.873 182.556 339.66Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.995 337.625C188.191 337.719 190.864 335.2 190.908 332.053C190.957 328.602 188.601 326.018 185.356 325.962C182.241 325.909 179.382 328.517 179.253 331.528C179.12 334.615 181.867 337.532 184.995 337.625Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.244 318.353C194.366 315.17 192.421 312.33 188.645 312.495C185.246 312.331 182.95 314.428 182.785 317.847C182.622 321.234 184.743 323.389 188.149 323.731C191.858 324.104 194.124 321.488 194.244 318.353Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.922 309.986C195.075 310.34 196.941 307.565 197.21 304.698C197.44 302.236 195.584 298.602 191.77 298.79C188.482 298.608 185.939 300.819 185.764 304.012C185.588 307.234 187.802 309.721 190.922 309.986Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.918 350.402C162.824 349.964 160.123 352.769 159.925 355.645C159.727 358.513 162.245 361.297 165.174 361.42C168.125 361.545 170.555 359.883 170.963 356.563C171.375 353.201 168.859 350.338 165.918 350.402Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.247 347.718C171.186 347.796 173.853 346.019 173.927 342.583C174.367 339.52 171.871 336.69 168.629 336.625C165.855 336.569 163.162 338.918 162.9 341.868C162.643 344.788 165.257 347.638 168.247 347.718Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.86 329.193C176.966 326.109 174.778 323.497 171.746 323.317C168.68 323.175 166.078 325.458 165.867 328.479C165.655 331.521 168.131 334.206 171.257 334.327C174.06 334.437 176.764 331.986 176.86 329.193Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.107 315.525C180.263 312.47 177.984 309.807 175.108 309.682C171.908 309.544 169.367 311.801 169.247 314.889C169.127 317.964 171.37 320.365 174.547 320.563C177.296 320.735 179.964 318.316 180.107 315.525Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.333 301.068C172.159 303.986 174.38 306.529 177.265 306.717C180.504 306.927 182.805 304.887 182.96 301.663C183.114 298.498 181.1 296.263 177.942 296.092C175.023 295.936 172.505 298.168 172.333 301.068Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.209 287.963C186.347 285.108 184.135 282.632 181.283 282.453C178.363 282.268 175.827 284.536 175.687 287.457C175.549 290.313 177.761 292.788 180.613 292.968C183.533 293.152 186.068 290.884 186.209 287.963Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.175 325.853C163.296 323.121 161.283 320.605 159.036 320.37C155.563 320.007 153.067 322.37 152.842 325.297C152.629 328.071 155.143 330.623 157.961 330.721C160.793 330.819 163.301 328.408 163.175 325.853Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.044 274.659C189.48 271.548 187.112 268.904 184.362 268.864C181.475 268.693 178.913 270.936 178.778 273.751C178.646 276.522 180.926 279.03 183.771 279.136C186.795 279.249 188.681 277.247 189.044 274.659Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.136 347.76C149.245 347.587 146.643 349.893 146.537 352.721C146.432 355.505 148.694 357.947 151.541 358.126C154.18 358.291 156.767 355.973 156.903 353.318C157.05 350.441 154.891 347.924 152.136 347.76Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.585 344.417C157.243 344.531 159.797 342.176 159.879 339.534C159.971 336.628 157.79 334.155 155.039 334.043C152.198 333.928 149.698 336.134 149.515 338.916C149.329 341.734 151.688 344.293 154.585 344.417Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.238 312.152C166.404 309.208 164.461 307.043 161.517 306.893C158.251 306.725 156.196 308.449 156.04 311.483C155.882 314.57 157.672 316.601 160.685 316.753C163.909 316.915 166.07 315.126 166.238 312.152Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.993 298.195C158.854 301.059 160.81 303.227 163.664 303.371C167.441 303.663 168.825 301.46 169.079 298.758C169.32 296.204 167.87 293.588 164.305 293.484C161.316 293.396 159.134 295.265 158.993 298.195Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.474 279.739C164.837 279.645 162.347 282.176 162.285 284.52C162.214 287.236 164.366 289.555 167.104 289.688C169.86 289.822 172.214 287.893 172.175 284.967C172.544 282.418 170.398 279.842 167.474 279.739Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.832 260.891C191.983 258.103 189.947 255.809 187.193 255.666C184.434 255.522 182.102 257.583 181.931 260.315C181.758 263.066 183.867 265.425 186.623 265.567C189.412 265.711 191.682 263.673 191.832 260.891Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.744 362.299C149.289 360.461 145.561 361.613 144.187 364.389C143.413 365.955 143.509 367.506 144.241 369.085C144.926 370.563 146.252 370.052 147.365 370.21C147.744 370.264 148.131 370.253 148.515 370.272C149.502 370.319 150.489 370.352 151.473 370.421C152.125 370.466 152.68 370.309 153.025 369.729C154.694 366.92 154.147 364.099 151.744 362.299Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.369 331.421C139.126 331.04 136.554 333.216 136.505 336.079C136.454 339.012 138.265 340.893 141.219 341.092C143.655 341.255 145.94 340.08 146.179 336.469C146.306 333.901 144.522 331.674 142.369 331.421Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.381 270.731C165.199 273.328 167.343 275.683 170.05 275.861C172.79 276.041 174.9 274.124 175.039 271.329C175.147 268.298 173.465 266.34 170.413 266.192C167.892 266.068 165.559 268.179 165.381 270.731Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.121 327.391C146.851 327.577 148.979 325.65 149.117 322.866C149.227 319.809 147.529 317.874 144.498 317.723C141.975 317.596 139.645 319.699 139.459 322.254C139.27 324.847 141.411 327.205 144.121 327.391Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.958 358.514C132.285 358.301 130.561 360.548 130.305 363.112C130.049 365.68 132.278 368.064 134.953 368.119C137.491 368.171 139.798 366.845 139.85 363.542C140.318 360.881 137.833 358.622 135.958 358.514Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.367 344.796C135.639 344.671 133.296 346.76 133.183 349.418C133.069 352.088 135.21 354.372 137.934 354.485C140.4 354.587 142.786 352.386 142.867 349.934C142.956 347.266 140.894 344.911 138.367 344.796Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.197 309.183C152.368 306.286 150.623 304.391 147.648 304.239C144.746 304.09 142.806 305.735 142.658 308.468C142.501 311.384 144.162 313.303 146.967 313.448C150.068 313.609 152.03 312.008 152.197 309.183Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.393 246.717C185.297 249.288 187.408 251.545 190.082 251.728C192.539 251.897 194.853 249.774 194.989 247.225C195.132 244.559 193.129 242.232 190.592 242.116C187.901 241.994 185.49 244.127 185.393 246.717Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.95 295.014C145.838 297.674 147.674 299.634 150.396 299.759C153.666 300.222 155.369 297.356 155.445 295.373C155.523 293.327 154.125 290.497 150.824 290.507C148.046 290.515 146.068 292.215 145.95 295.014Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.876 257.019C168.705 259.576 170.572 261.757 173.103 261.958C175.749 262.167 177.906 260.275 178.166 257.676C178.424 255.091 175.976 252.576 174.014 252.705C171.259 252.5 169.055 254.352 168.876 257.019Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.915 281.563C148.81 283.996 150.863 286.24 153.309 286.37C156.093 286.517 157.965 284.836 158.128 282.045C158.291 279.239 156.643 277.347 153.873 277.163C151.358 276.994 149.023 279.067 148.915 281.563Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.98 267.756C151.795 270.086 154.025 272.562 156.449 272.56C158.67 272.559 160.929 271.401 161.014 268.355C161.447 265.808 159.189 263.505 156.819 263.507C154.471 263.509 152.167 265.42 151.98 267.756Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.352 314.734C127.938 314.622 126.444 316.605 126.154 319.003C125.868 321.374 127.956 323.623 130.47 323.716C132.944 323.808 135.154 322.272 135.081 319.473C135.648 317.15 133.096 314.793 131.352 314.734Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.092 342.137C121.682 342.037 120.186 343.967 119.878 346.396C119.571 348.812 121.833 351.159 124.339 351.14C127.027 351.12 128.911 349.349 128.803 346.899C129.403 344.572 126.775 342.187 125.092 342.137Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.943 243.687C171.796 246.08 173.808 248.295 176.292 248.478C178.604 248.649 180.883 246.619 180.997 244.287C181.121 241.756 179.208 239.534 176.807 239.42C174.33 239.301 172.092 241.264 171.943 243.687Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.988 328.473C125.409 328.336 123.136 330.381 123.114 332.861C123.091 335.357 125.094 337.405 127.617 337.468C129.904 337.525 132.045 335.506 132.112 333.23C132.187 330.747 130.322 328.597 127.988 328.473Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.003 364.127C159.319 364.025 157.025 365.966 156.712 369.42C156.647 370.148 156.795 370.851 157.968 370.768C159.378 370.667 160.81 370.865 162.233 370.934C163.491 370.995 164.752 371.025 166.007 371.127C167.05 371.212 167.722 371.349 167.679 369.743C167.603 366.973 165.568 364.197 163.003 364.127Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.725 356.101C118.981 355.96 117.199 357.48 117.065 360.077C116.926 362.773 118.48 364.521 121.133 364.653C123.811 364.786 125.806 363.141 125.946 360.686C126.089 358.141 124.336 356.236 121.725 356.101Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.156 306.17C138.331 303.733 136.548 301.747 134.055 301.601C131.289 301.44 129.421 302.964 129.277 305.501C129.128 308.123 130.693 309.995 133.157 310.14C136 310.308 137.971 308.744 138.156 306.17Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.522 254.09C155.382 256.583 157.066 258.481 159.553 258.634C162.248 258.8 164.32 257.053 164.413 254.537C164.501 252.186 162.739 250.23 160.41 250.093C157.6 249.926 155.668 251.506 155.522 254.09Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.461 292.468C141.63 290.081 139.823 288.045 137.413 287.907C134.637 287.747 132.701 289.367 132.572 291.956C132.449 294.446 134.141 296.31 136.655 296.453C139.276 296.602 141.285 294.936 141.461 292.468Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.598 278.197C135.493 280.608 136.767 282.444 139.688 282.707C142.2 282.933 143.923 281.339 144.135 278.771C144.341 276.286 142.514 274.089 140.181 274.19C138.138 273.904 135.714 275.504 135.598 278.197Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.147 230.062C175.049 232.443 176.851 234.411 179.234 234.528C181.682 234.649 183.685 232.781 183.748 230.321C183.808 227.95 181.965 226.011 179.575 225.932C177.197 225.853 175.245 227.674 175.147 230.062Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.156 236.439C160.885 236.309 158.721 238.217 158.561 240.489C158.421 242.497 160.52 244.854 162.594 244.831C164.958 244.805 166.758 243.964 167.02 240.596C167.171 238.643 165.419 236.333 163.156 236.439Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.95 264.577C138.86 266.718 140.749 268.772 142.969 268.946C145.251 269.124 147.134 267.559 147.27 265.371C147.447 262.537 146.081 260.763 143.605 260.606C141.246 260.456 139.044 262.335 138.95 264.577Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.655 339.552C108.906 339.475 106.821 341.226 106.802 343.629C106.783 345.869 108.629 347.762 110.917 347.849C113.304 347.941 114.987 346.387 115.07 344.017C115.157 341.504 113.709 339.611 111.655 339.552Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.602 325.832C112.416 325.69 110.047 326.911 109.799 329.784C109.602 332.054 111.58 334.073 113.922 334.138C116.322 334.204 117.954 332.675 118.046 330.276C118.14 327.783 116.671 325.967 114.602 325.832Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.796 320.237C119.397 320.355 121.256 318.88 121.114 316.439C120.974 314.025 119.993 312.255 117.08 312.292C114.523 312.325 113.027 313.6 112.918 316.217C112.819 318.62 114.268 320.121 116.796 320.237Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.411 302.846C124.342 300.562 123.407 298.57 120.387 298.628C117.93 298.508 116.342 299.954 116.228 302.415C116.115 304.852 117.578 306.427 120.058 306.537C122.639 306.653 124.483 305.251 124.411 302.846Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.79 353.013C105.503 352.926 103.674 354.627 103.586 356.923C103.499 359.21 105.202 361.04 107.497 361.127C109.784 361.214 111.614 359.512 111.701 357.216C111.787 354.929 110.086 353.1 107.79 353.013Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.041 212.588C180.603 212.434 178.921 213.799 178.79 216.037C178.637 218.641 179.968 220.378 182.206 220.497C184.811 220.635 186.944 218.966 187.031 216.723C187.11 214.628 185.279 212.729 183.041 212.588Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.803 226.584C161.63 228.896 163.187 230.719 165.469 230.878C167.871 231.045 169.821 229.475 170.028 227.207C170.213 225.169 168.333 223.117 166.158 222.985C163.772 222.841 161.97 224.33 161.803 226.584Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.422 289.407C127.525 287.346 125.757 285.406 123.644 285.259C121.167 285.087 119.337 286.592 119.191 288.921C119.046 291.225 120.624 293.009 122.929 293.15C125.341 293.298 127.311 291.657 127.422 289.407Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.096 251.185C141.985 253.476 143.673 255.3 145.976 255.375C148.194 255.448 149.972 253.802 150.08 251.575C150.191 249.284 148.503 247.46 146.201 247.385C143.982 247.312 142.205 248.957 142.096 251.185Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.043 275.754C130.397 273.516 128.605 271.545 126.502 271.54C124.255 271.535 122.246 273.209 122.181 275.345C122.117 277.433 123.936 279.36 126.058 279.42C128.412 279.486 130.061 278.005 130.043 275.754Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.81 202.694C181.737 204.688 183.551 206.648 185.551 206.735C187.976 206.841 189.533 205.396 189.636 202.942C189.736 200.55 188.348 199.025 185.971 198.918C183.888 198.824 181.885 200.642 181.81 202.694Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.574 261.552C125.431 263.648 127.202 265.61 129.374 265.628C131.708 265.647 133.089 264.512 133.265 261.983C133.469 259.633 131.816 258.092 130.174 258C127.617 257.853 125.728 259.3 125.574 261.552Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.193 213.32C165.046 215.414 166.817 217.38 168.987 217.4C171.331 217.421 172.703 216.28 172.883 213.759C173.092 211.337 171.353 209.797 169.633 209.754C167.161 209.692 165.346 211.126 165.193 213.32Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.302 233.779C147.063 233.752 145.231 235.417 145.168 237.537C145.106 239.621 146.827 241.477 148.899 241.559C150.979 241.643 152.847 239.939 152.953 237.863C153.057 235.804 151.269 233.804 149.302 233.779Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8719 313.17C99.7727 315.363 101.148 316.644 103.346 316.996C105.349 317.317 107.451 315.265 107.464 313.466C107.478 311.459 106.005 309.816 103.982 309.711C101.473 309.58 99.977 310.839 99.8719 313.17Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.786 323.413C98.2044 323.271 96.7075 324.461 96.5747 326.76C96.4412 329.058 97.7775 330.525 100.11 330.643C102.317 330.756 104.005 329.344 104.143 327.27C104.277 325.254 102.77 323.522 100.786 323.413Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7466 336.792C95.2226 336.658 93.7241 337.902 93.6118 340.224C93.5049 342.422 94.8753 343.722 97.0586 344.074C99.1004 344.402 101.172 342.353 101.2 340.573C101.233 338.577 99.7451 336.898 97.7466 336.792Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2826 350.482C92.0247 350.361 90.4094 351.767 90.3089 353.938C90.2114 356.054 91.7 357.472 93.8639 357.765C95.7466 358.021 97.7303 356.449 97.8742 354.302C98.0159 352.212 96.4755 350.599 94.2826 350.482Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.742 223.81C148.646 225.915 150.155 227.507 152.339 227.601C154.448 227.692 156.135 226.262 156.314 224.23C156.492 222.227 154.829 220.463 152.661 220.354C150.484 220.243 148.84 221.695 148.742 223.81Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.768 247.9C128.666 250.01 130.17 251.609 132.348 251.707C134.509 251.803 136.349 250.185 136.347 248.188C136.345 246.133 134.817 244.572 132.701 244.46C130.525 244.347 128.871 245.791 128.768 247.9Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.143 299.771C110.237 297.723 108.755 296.066 106.716 295.937C104.597 295.804 102.892 297.329 102.796 299.443C102.703 301.491 104.184 303.148 106.223 303.277C108.342 303.41 110.048 301.884 110.143 299.771Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.396 199.748C168.376 201.645 170.043 203.395 171.97 203.462C174.137 203.537 175.527 202.202 175.62 199.958C175.958 198.095 174.271 196.23 172.095 196.185C170.231 196.145 168.414 198.205 168.396 199.748Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.781 366.756C174.163 366.67 172.051 367.604 170.716 369.971C170.234 370.826 170.037 371.381 171.459 371.411C174.852 371.483 178.244 371.71 181.703 371.878C181.581 371.4 181.519 371.088 181.423 370.786C180.732 368.633 178.689 366.819 176.781 366.756Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.07 188.883C184.917 190.87 186.473 192.626 188.49 192.739C190.51 192.853 192.222 191.316 192.325 189.297C192.423 187.36 190.921 185.603 189.075 185.495C186.918 185.369 185.231 186.795 185.07 188.883Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.072 286.095C113.178 284.157 111.682 282.393 109.838 282.279C107.678 282.146 105.988 283.563 105.819 285.65C105.658 287.636 107.207 289.399 109.222 289.521C111.241 289.643 112.961 288.112 113.072 286.095Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.331 272.377C116.436 270.279 115.098 268.752 113.038 268.62C111.105 268.496 109.259 270.115 109.162 272.019C109.066 273.917 110.747 275.718 112.68 275.787C114.742 275.862 116.227 274.475 116.331 272.377Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.808 210.17C151.771 212.033 153.316 213.696 155.168 213.785C157.081 213.878 158.833 212.252 158.87 210.348C158.907 208.485 157.362 206.822 155.51 206.733C153.598 206.639 151.846 208.265 151.808 210.17Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.131 234.19C132.028 236.09 133.602 237.84 135.505 237.945C137.405 238.048 139.155 236.473 139.26 234.57C139.363 232.671 137.788 230.92 135.885 230.816C133.986 230.713 132.234 232.286 132.131 234.19Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.412 258.667C112.316 260.706 113.504 261.997 115.579 262.11C117.871 262.234 119.239 261.087 119.328 258.966C119.412 256.949 118.224 255.646 116.203 255.539C113.823 255.413 112.515 256.492 112.412 258.667Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.455 296.577C89.4048 298.47 90.7509 299.864 92.698 299.935C94.7008 300.009 96.2201 298.743 96.3806 296.867C96.5465 294.936 94.9734 293.378 92.8076 293.33C90.9103 293.287 89.5062 294.646 89.455 296.577Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5053 309.83C86.4024 311.776 87.6236 313.173 89.5442 313.308C91.7716 313.463 93.2918 312.253 93.4226 310.219C93.5418 308.371 92.1649 306.861 90.2442 306.735C88.0417 306.59 86.6139 307.772 86.5053 309.83Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9222 334.141C81.8029 334.011 80.3756 335.163 80.2339 337.119C80.0856 339.159 81.3087 340.588 83.3116 340.717C85.5181 340.859 87.0713 339.59 87.1472 337.582C87.2186 335.69 85.8804 334.262 83.9222 334.141Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38 244.967C115.298 246.877 116.61 248.304 118.54 248.401C120.617 248.506 122.245 247.145 122.307 245.252C122.37 243.337 120.893 241.88 118.81 241.802C116.892 241.731 115.463 243.05 115.38 244.967Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.362 220.761C135.243 222.719 136.445 224.139 138.349 224.285C140.61 224.458 142.078 223.323 142.274 221.248C142.442 219.462 141.014 217.849 139.147 217.717C136.939 217.562 135.485 218.731 135.362 220.761Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9899 320.434C84.7809 320.278 83.3282 321.446 83.2044 323.477C83.0853 325.436 84.2877 326.856 86.1915 327.001C88.4532 327.175 89.9206 326.04 90.1165 323.964C90.2849 322.178 88.8571 320.566 86.9899 320.434Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6994 347.839C78.7768 347.759 77.3419 349.067 77.2497 350.981C77.1588 352.894 78.4629 354.33 80.386 354.435C82.4581 354.548 84.0853 353.204 84.1734 351.31C84.2625 349.415 82.7709 347.925 80.6994 347.839Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.981 185.967C171.879 187.847 173.218 189.362 175.087 189.483C176.968 189.603 178.503 188.282 178.641 186.42C178.781 184.536 177.477 182.984 175.622 182.828C173.669 182.662 172.087 184.027 171.981 185.967Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.025 196.454C154.985 198.21 156.512 199.786 158.305 199.838C160.196 199.892 161.535 198.592 161.601 196.638C161.665 194.734 160.359 193.318 158.489 193.262C156.708 193.21 155.065 194.724 155.025 196.454Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4489 282.746C92.3544 284.486 93.8554 286.115 95.6413 286.209C97.53 286.308 98.9156 285.03 99.0171 283.097C99.118 281.151 97.8858 279.743 95.9925 279.642C94.1954 279.546 92.5448 280.992 92.4489 282.746Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.807 269.108C95.7567 270.782 97.2203 272.384 98.9585 272.442C100.819 272.504 102.305 271.482 102.261 269.385C102.356 267.433 101.257 266.088 99.5189 266.03C97.5177 265.962 95.8599 267.337 95.807 269.108Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.756 231.277C118.695 232.946 120.155 234.558 121.894 234.622C123.746 234.692 125.245 233.682 125.209 231.579C125.306 229.62 124.217 228.276 122.48 228.213C120.478 228.141 118.82 229.504 118.756 231.277Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.434 207.016C138.276 208.737 139.698 210.376 141.441 210.481C143.171 210.585 144.777 209.118 144.827 207.389C144.876 205.707 143.49 204.189 141.813 204.088C140.148 203.988 138.589 205.339 138.434 207.016Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0393 255.388C98.954 257.276 100.019 258.394 101.99 258.486C103.982 258.579 105.23 257.511 105.309 255.65C105.385 253.825 104.211 252.639 102.236 252.547C100.279 252.456 99.1254 253.481 99.0393 255.388Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.223 172.215C175.099 173.979 176.345 175.403 178.103 175.507C179.869 175.61 181.274 174.349 181.357 172.585C181.437 170.885 180.24 169.515 178.555 169.378C176.79 169.234 175.346 170.464 175.223 172.215Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6412 361.555C75.6233 361.435 74.0129 362.814 73.949 364.718C73.9243 365.448 74.0793 366.46 74.661 366.556C76.3726 366.84 78.1358 366.817 79.88 366.876C80.04 366.882 80.261 366.66 80.3661 366.489C81.5817 364.51 80.0222 361.696 77.6412 361.555Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.637 180.149C159.941 180.118 158.625 181.387 158.574 183.102C158.524 184.804 159.773 186.135 161.484 186.205C163.196 186.273 164.537 185.05 164.625 183.338C164.717 181.563 163.423 180.183 161.637 180.149Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3121 331.505C68.3981 331.39 66.9029 332.613 66.8434 334.346C66.7875 335.949 68.0952 337.321 69.7745 337.42C71.5021 337.522 72.9671 336.292 73.0885 334.638C73.2005 333.114 71.8578 331.6 70.3121 331.505Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7039 317.814C71.7795 317.678 70.2643 318.849 70.1511 320.56C70.0462 322.153 71.3371 323.591 72.9885 323.719C74.7282 323.855 76.1665 322.717 76.387 321.03C76.5817 319.55 75.2228 317.922 73.7039 317.814Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.125 306.859C73.0253 308.456 74.3161 309.882 75.9736 310.008C77.7113 310.139 79.1536 308.99 79.3623 307.308C79.5471 305.821 78.1917 304.208 76.6683 304.101C74.7474 303.968 73.232 305.148 73.125 306.859Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.966 217.567C121.892 219.266 123.165 220.633 124.871 220.686C126.562 220.739 127.916 219.444 127.95 217.74C127.983 216.112 126.757 214.796 125.125 214.706C123.426 214.612 122.04 215.867 121.966 217.567Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2846 358.629C62.6591 358.44 61.1052 359.672 60.9451 361.277C60.7939 362.793 62.0247 364.285 63.584 364.475C65.3482 364.69 66.6101 363.679 66.8016 361.898C66.9971 360.074 66.0421 358.834 64.2846 358.629Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1206 344.879C65.4971 344.777 63.9868 346.081 63.8923 347.662C63.7971 349.25 65.1456 350.715 66.7781 350.799C68.6277 350.893 69.708 349.898 69.8125 348.006C69.9179 346.09 68.9731 344.994 67.1206 344.879Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.972 193.374C141.853 194.946 143.196 196.447 144.813 196.55C146.678 196.67 147.766 195.697 147.889 193.802C148.013 191.884 147.085 190.773 145.242 190.635C143.62 190.512 142.092 191.792 141.972 193.374Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.352 241.644C102.257 243.231 103.606 244.697 105.238 244.779C107.088 244.873 108.168 243.879 108.273 241.986C108.379 240.072 107.434 238.975 105.58 238.86C103.958 238.759 102.447 240.062 102.352 241.644Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0962 293.254C76.0611 294.84 77.4561 296.262 79.0832 296.299C80.9319 296.341 81.9635 295.325 82.0267 293.405C82.0882 291.506 81.1013 290.432 79.2337 290.37C77.6116 290.314 76.1305 291.675 76.0962 293.254Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4675 279.476C79.3621 280.857 80.7977 282.409 82.2595 282.539C83.8134 282.678 85.1172 281.622 85.2342 280.127C85.4093 277.884 84.7068 276.902 82.8216 276.758C81.1148 276.238 79.5575 278.284 79.4675 279.476Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.269 201.128C126.646 201.036 125.161 202.305 125.09 203.848C125.021 205.326 126.329 206.723 127.894 206.84C129.372 206.952 130.711 205.701 130.791 204.138C130.874 202.505 129.792 201.215 128.269 201.128Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.432 228.254C105.327 229.722 106.615 231.138 108.189 231.287C109.698 231.429 111.039 230.219 111.129 228.634C111.222 227.002 110.154 225.684 108.654 225.581C107.034 225.469 105.541 226.708 105.432 228.254Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.652 155.878C180.038 155.763 178.537 157.001 178.423 158.543C178.309 160.069 179.728 161.556 181.336 161.594C182.783 161.628 184.034 160.436 184.12 158.938C184.213 157.306 183.146 155.983 181.652 155.878Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5162 266.177C82.4792 267.667 83.6399 268.945 85.1272 269.051C86.6781 269.162 88.0401 267.96 88.1262 266.406C88.2125 264.855 86.9895 263.508 85.4373 263.446C83.881 263.383 82.5545 264.623 82.5162 266.177Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.772 169.301C161.68 170.851 162.899 172.202 164.451 172.271C165.941 172.336 167.241 171.2 167.373 169.714C167.512 168.17 166.331 166.782 164.781 166.666C163.233 166.55 161.864 167.748 161.772 169.301Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.173 177.246C146.416 177.148 145.349 178.069 145.267 179.749C145.188 181.362 146.134 182.412 147.755 182.512C149.574 182.624 150.743 181.718 150.866 180.101C150.992 178.466 149.933 177.344 148.173 177.246Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6606 252.425C85.594 253.942 86.6183 255.054 88.1913 255.174C89.9037 255.305 91.1634 254.29 91.2596 252.702C91.3518 251.185 90.2645 250.009 88.6777 249.914C86.9191 249.809 85.7325 250.796 85.6606 252.425Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.608 214.545C108.507 216.05 109.592 217.246 111.163 217.361C112.695 217.474 114.06 216.37 114.197 214.91C114.32 213.613 113.068 212.219 111.678 212.102C109.998 211.961 108.713 212.984 108.608 214.545Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7442 236.219C90.2993 236.168 89.058 237.28 88.9782 238.696C88.8982 240.109 90.0134 241.354 91.4544 241.463C93.039 241.583 94.1347 240.602 94.2214 238.986C94.3091 237.35 93.3468 236.275 91.7442 236.219Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4925 314.826C58.0485 314.812 56.8287 315.962 56.7913 317.375C56.7534 318.796 57.8917 320.003 59.339 320.077C60.9362 320.157 61.9865 319.167 62.0422 317.528C62.0963 315.911 61.0871 314.841 59.4925 314.826Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2907 328.551C54.9053 328.453 53.5897 329.621 53.5155 331.012C53.4453 332.332 54.5308 333.597 55.8547 333.738C57.2251 333.885 58.5839 332.754 58.7076 331.365C58.8308 329.989 57.6803 328.65 56.2907 328.551Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.767 158.329C169.096 158.386 170.354 157.252 170.435 155.922C170.521 154.536 169.289 153.213 167.906 153.207C166.574 153.202 165.347 154.382 165.317 155.7C165.286 157.031 166.444 158.273 167.767 158.329Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.051 193.243C132.542 193.339 133.83 192.151 133.854 190.658C133.877 189.228 132.732 188.026 131.304 187.981C129.873 187.935 128.655 189.06 128.588 190.488C128.518 191.917 129.624 193.152 131.051 193.243Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6321 342.31C52.0343 342.22 50.6017 343.356 50.5498 344.755C50.5024 346.022 51.7639 347.359 53.0941 347.454C54.5548 347.556 55.664 346.497 55.7311 344.934C55.7975 343.414 54.9738 342.385 53.6321 342.31Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7828 304.01C59.77 305.287 61.0524 306.598 62.3776 306.663C63.8045 306.733 64.8814 305.731 64.9617 304.258C65.0503 302.627 64.2293 301.572 62.8212 301.511C61.233 301.441 59.797 302.622 59.7828 304.01Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0898 290.258C63.0366 291.527 64.2913 292.866 65.6257 292.964C67.0789 293.071 68.2016 292.005 68.27 290.453C68.3372 288.93 67.519 287.9 66.1791 287.823C64.5798 287.73 63.1472 288.859 63.0898 290.258Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.547 147.957C185.971 148.029 187.055 147.023 187.136 145.556C187.225 143.923 186.406 142.868 184.999 142.805C183.409 142.733 181.975 143.91 181.958 145.3C181.941 146.576 183.221 147.889 184.547 147.957Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7703 356.043C49.1591 355.919 47.7113 357.033 47.6412 358.448C47.5763 359.761 48.8014 361.044 50.1909 361.119C51.6463 361.198 52.6005 360.328 52.7038 358.829C52.8096 357.292 52.0089 356.138 50.7703 356.043Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.899 169.014C152.252 168.965 153.359 168.582 153.41 166.574C153.469 165.142 152.653 164.05 151.457 163.964C149.84 163.848 148.399 164.964 148.339 166.38C148.282 167.695 149.516 169.064 150.899 169.014Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1653 276.482C66.0662 277.847 67.1476 279.072 68.5167 279.148C69.8202 279.219 70.9931 278.219 71.1327 276.917C71.2785 275.56 70.235 274.297 68.8699 274.174C67.5091 274.052 66.264 275.115 66.1653 276.482Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2683 224.959C92.172 226.615 92.8487 227.356 94.5362 227.441C96.3391 227.531 97.1452 226.865 97.211 225.232C97.2762 223.637 96.5096 222.899 94.7104 222.822C93.1107 222.755 92.3587 223.413 92.2683 224.959Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.881 198.727C113.128 198.617 112.345 199.24 112.244 200.822C112.138 202.489 112.81 203.245 114.479 203.334C116.263 203.429 117.104 202.753 117.185 201.159C117.263 199.601 116.533 198.829 114.881 198.727Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8188 364.151C89.1297 364.191 88.0051 365.161 87.3485 367.306C89.5233 367.412 91.5971 367.466 93.6615 367.631C94.7639 367.719 94.6918 367.282 94.3875 366.511C93.8011 365.028 92.4544 364.112 90.8188 364.151Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3187 262.847C69.2513 264.339 70.0833 265.187 71.6856 265.26C73.1064 265.325 74.2071 264.385 74.2612 263.061C74.3133 261.784 73.2555 260.71 71.8842 260.646C70.2838 260.573 69.3861 261.343 69.3187 262.847Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.283 179.217C135.647 179.272 136.802 178.26 136.83 176.986C136.858 175.71 135.793 174.655 134.42 174.601C132.828 174.537 131.937 175.321 131.884 176.832C131.833 178.315 132.676 179.154 134.283 179.217Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3875 247.303C74.0421 247.162 72.7854 248.059 72.618 249.278C72.4495 250.506 73.4936 251.763 74.787 251.887C76.1052 252.014 77.4441 250.965 77.5378 249.732C77.6164 248.685 76.4953 247.418 75.3875 247.303Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8856 214.077C99.1282 214.141 100.381 213.106 100.484 211.926C100.582 210.825 99.3867 209.545 98.1842 209.466C96.8512 209.379 95.6358 210.37 95.5537 211.612C95.4723 212.856 96.5625 214.008 97.8856 214.077Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.677 189.595C119.019 189.626 119.736 188.886 119.802 187.397C119.873 185.804 119.239 185.088 117.711 185.036C116.467 184.993 115.26 186.078 115.24 187.255C115.221 188.471 116.361 189.564 117.677 189.595Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.994 144.342C172.339 144.381 173.063 143.644 173.132 142.158C173.206 140.555 172.58 139.837 171.056 139.782C169.807 139.738 168.6 140.809 168.571 141.988C168.542 143.203 169.675 144.303 170.994 144.342Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.972 371.942C188.321 372.104 191.42 372.255 194.613 372.409C191.698 369.158 188.162 368.948 184.972 371.942Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.377 133.897C188.522 133.974 189.64 133.027 189.767 131.875C189.899 130.677 188.885 129.482 187.667 129.4C186.458 129.32 185.301 130.374 185.27 131.585C185.241 132.744 186.222 133.82 187.377 133.897Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.279 155.028C155.684 155.019 156.313 154.216 156.394 152.902C156.478 151.541 155.631 150.6 154.328 150.567C153.073 150.535 151.93 151.586 151.93 152.772C151.93 153.977 153.027 155.036 154.279 155.028Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6528 235.83C75.6442 237.036 76.7365 238.105 77.988 238.1C79.3871 238.096 80.0289 237.302 80.1152 235.985C80.204 234.627 79.3599 233.678 78.0618 233.639C76.8081 233.6 75.6618 234.643 75.6528 235.83Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7032 339.724C38.3947 339.676 37.3664 340.513 37.2877 341.754C37.2085 343.017 38.2055 344.113 39.5278 344.026C40.7128 343.949 41.758 343.544 41.6117 342.223C41.6359 340.682 41.2098 339.779 39.7032 339.724Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8421 286.957C49.778 288.164 50.6643 289.121 51.9404 289.223C53.2945 289.331 54.0753 288.601 54.1694 286.605C54.159 285.863 53.7538 284.945 52.2383 284.904C50.9377 284.87 49.9077 285.717 49.8421 286.957Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.039 326.034C41.7223 325.953 40.6911 326.785 40.5926 328.025C40.4928 329.285 41.4741 330.396 42.7983 330.33C43.9837 330.271 45.015 329.863 44.9133 328.629C44.9931 326.991 44.5085 326.124 43.039 326.034Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8867 298.606C47.6018 298.545 46.5703 299.465 46.5363 300.702C46.5027 301.917 47.4037 302.919 48.6848 302.903C49.8904 302.888 50.8869 302.475 50.8402 300.873C50.9236 299.448 50.2851 298.671 48.8867 298.606Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.477 165.34C138.675 165.335 139.688 164.945 139.665 163.191C139.745 161.903 139.116 161.119 137.728 161.047C136.435 160.98 135.404 161.878 135.354 163.116C135.305 164.325 136.202 165.346 137.477 165.34Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8377 312.296C44.6528 312.223 43.5711 313.199 43.5221 314.385C43.4725 315.573 44.472 316.684 45.6547 316.65C46.9232 316.614 47.7064 315.907 47.8724 314.649C48.0262 313.476 47.0247 312.37 45.8377 312.296Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6926 353.288C35.4206 353.243 34.61 353.774 34.4988 355.117C34.392 356.407 35.1727 357.133 36.5586 357.273C37.9841 357.416 38.5198 356.522 38.7422 355.431C38.9737 354.293 37.9795 353.353 36.6926 353.288Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.833 200.035C102.137 200.099 103.211 199.321 103.107 198.15C103.011 197.06 102.596 196.028 101.161 196.083C99.7809 195.996 98.8867 196.705 98.8639 197.967C98.8414 199.276 99.5087 199.969 100.833 200.035Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7598 224.148C82.2095 224.375 82.9842 223.494 83.0936 222.36C83.1912 221.353 82.7265 220.241 81.3138 220.197C79.9592 220.059 78.9626 220.758 78.8941 221.961C78.8199 223.253 79.4702 223.946 80.7598 224.148Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.44 175.923C121.891 176.11 122.64 175.225 122.719 174.072C122.789 173.038 122.284 171.965 120.869 171.964C119.508 171.848 118.546 172.565 118.509 173.795C118.469 175.094 119.153 175.756 120.44 175.923Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2085 273.831C57.1347 272.747 56.7575 271.689 55.3102 271.723C53.9223 271.622 53.0172 272.312 52.9701 273.558C52.9207 274.868 53.5806 275.573 54.8922 275.665C56.1913 275.756 57.2869 274.99 57.2085 273.831Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2869 259.923C56.3458 261.159 57.0805 261.913 58.3288 261.952C59.481 261.989 60.312 261.532 60.1972 260.252C60.3389 258.93 60.0666 258.039 58.554 258.015C57.3034 257.997 56.2327 258.782 56.2869 259.923Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.769 130.6C174.888 130.632 175.645 129.951 175.729 128.837C175.82 127.638 175.127 126.838 173.932 126.754C172.724 126.671 172.062 127.425 171.842 128.587C171.962 129.771 172.557 130.568 173.769 130.6Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.06 141.024C158.28 141.009 158.965 140.45 159.06 139.29C159.158 138.083 158.636 137.256 157.377 137.179C156.174 137.105 155.329 137.78 155.247 138.962C155.162 140.159 155.957 140.829 157.06 141.024Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.902 186.255C105.164 186.27 105.74 185.48 105.739 184.276C105.739 183.104 105.084 182.51 103.836 182.392C102.777 182.526 101.911 183.107 101.912 184.317C101.912 185.496 102.691 186.241 103.902 186.255Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.444 151.436C141.781 151.382 142.388 150.687 142.401 149.47C142.413 148.307 141.791 147.613 140.642 147.585C139.441 147.557 138.611 148.245 138.573 149.435C138.535 150.628 139.341 151.283 140.444 151.436Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1821 248.218C62.5129 248.176 63.1258 247.486 63.148 246.269C63.169 245.108 62.5592 244.403 61.4057 244.367C60.2047 244.33 59.3712 245.011 59.322 246.201C59.2723 247.398 60.0759 248.054 61.1821 248.218Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1466 210.374C85.2938 210.462 85.9833 209.831 86.0835 208.672C86.1879 207.466 85.6611 206.704 84.3354 206.522C83.2171 206.565 82.3516 207.139 82.2708 208.328C82.1904 209.517 82.9493 210.284 84.1466 210.374Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.301 336.946C25.1706 336.884 24.5387 337.359 24.3755 338.594C24.4305 339.586 24.9302 340.183 26.0801 340.268C27.3019 340.359 27.935 339.653 27.9961 338.64C28.0547 337.652 27.403 337.008 26.301 336.946Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.683 161.899C124.952 162.04 125.684 161.469 125.719 160.304C125.746 159.399 125.368 158.499 124.181 158.599C122.991 158.465 122.214 158.792 122.131 160.091C122.059 161.22 122.531 161.772 123.683 161.899Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3359 309.855C31.2317 309.778 30.5408 310.16 30.3231 311.294C30.3031 312.384 30.7338 313.056 31.9077 313.162C33.066 313.267 33.8575 312.732 33.9208 311.647C33.9729 310.739 33.4983 309.937 32.3359 309.855Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3834 234.226C65.5702 234.444 66.0974 233.614 66.129 232.604C66.1624 231.556 65.5829 230.876 64.3384 230.894C63.2164 230.911 62.6049 231.294 62.5363 232.458C62.4628 233.724 63.1058 234.229 64.3834 234.226Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4129 285.766C39.5691 285.819 40.1572 285.111 40.2038 284.176C40.2583 283.097 39.585 282.402 38.372 282.442C37.261 282.43 36.6221 282.958 36.621 284.109C36.6182 285.281 37.3115 285.714 38.4129 285.766Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5678 196.445C88.3844 196.554 89.0163 195.797 89.0742 194.784C89.13 193.803 88.4812 193.148 87.3766 193.096C86.2585 193.043 85.5694 193.477 85.4946 194.641C85.4209 195.8 86.0491 196.341 87.5678 196.445Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6232 297.74C33.6507 298.871 34.2206 299.404 35.3543 299.478C36.4887 299.553 37.1534 298.92 37.2229 297.971C37.2992 296.941 36.6891 296.205 35.4964 296.153C34.355 296.103 33.7504 296.611 33.6232 297.74Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2387 323.235C28.1373 323.183 27.4417 323.638 27.3892 324.805C27.3372 325.963 27.9609 326.466 29.0828 326.556C30.2234 326.648 30.8775 325.999 30.9612 325.06C31.0541 324.02 30.4331 323.269 29.2387 323.235Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.001 172.274C108.022 172.345 108.671 171.773 108.748 170.752C108.825 169.72 108.215 169.163 107.231 168.969C106.223 169.024 105.544 169.496 105.478 170.527C105.413 171.55 105.981 172.203 107.001 172.274Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4539 220.832C68.5445 220.964 68.9652 220.298 69.1325 219.376C69.1265 218.404 68.888 217.633 67.7593 217.575C66.6746 217.521 65.938 218.073 65.8735 219.127C65.8141 220.102 66.4609 220.713 67.4539 220.832Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3689 272.02C42.4704 272.056 42.8285 271.346 42.9045 270.218C42.7954 269.456 42.4876 268.714 41.3719 268.751C40.3731 268.784 39.6693 269.325 39.6372 270.301C39.6036 271.354 40.2834 271.985 41.3689 272.02Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.318 127.009C161.322 126.99 161.7 126.363 161.752 125.459C161.81 124.451 161.38 123.836 160.107 123.713C159.313 123.828 158.482 124.273 158.509 125.364C158.533 126.391 159.204 127.03 160.318 127.009Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.306 116.617C178.315 116.607 178.696 115.983 178.75 115.076C178.811 114.072 178.391 113.45 177.228 113.329C176.286 113.387 175.501 113.891 175.509 114.961C175.517 115.99 176.195 116.627 177.306 116.617Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9083 350.665C21.9071 350.675 21.2016 351.219 21.1536 352.191C21.1023 353.247 21.7801 353.877 22.8618 353.935C23.976 353.994 24.3317 353.281 24.4145 352.223C24.3539 351.359 24.0041 350.655 22.9083 350.665Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6408 258.591C45.6658 258.631 46.0823 258.02 46.1012 256.986C46.1821 256.081 45.7396 255.489 44.7429 255.455C43.7315 255.42 43.0157 255.982 42.9872 256.964C42.9586 257.939 43.6223 258.55 44.6408 258.591Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.902 148.093C127.954 148.115 128.305 147.465 128.334 146.36C128.408 145.53 127.913 144.975 126.934 144.959C125.928 144.942 125.211 145.515 125.212 146.504C125.212 147.471 125.871 148.071 126.902 148.093Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.389 137.694C144.326 137.705 144.975 137.126 145.005 136.189C145.038 135.173 144.407 134.508 143.385 134.529C142.458 134.546 141.931 135.177 141.804 136.148C141.97 137.012 142.43 137.683 143.389 137.694Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5453 244.646C48.53 244.698 49.1209 244.328 49.1427 243.339C49.1651 242.335 48.5388 242.001 47.588 241.962C46.5993 241.921 46.141 242.3 46.1834 243.267C46.0542 244.32 46.6235 244.598 47.5453 244.646Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.438 182.698C91.3678 182.863 91.9897 182.465 92.059 181.485C92.1288 180.499 91.5528 180.092 90.5785 180.045C89.6397 180.001 89.1364 180.265 89.0881 181.29C89.041 182.271 89.4096 182.742 90.438 182.698Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5284 206.829C71.5335 206.884 72.0866 206.477 72.0963 205.485C72.1066 204.448 71.4341 204.183 70.5017 204.142C69.4872 204.099 69.0873 204.541 69.1304 205.47C69.011 206.558 69.63 206.781 70.5284 206.829Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.226 158.26C111.074 158.292 111.625 157.895 111.707 157.091C111.799 156.192 111.281 155.683 110.367 155.612C109.449 155.54 108.838 155.945 108.79 156.86C108.744 157.775 109.304 158.227 110.226 158.26Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.019 367.946C104 368.043 105.921 368.136 107.923 368.232C106.064 366.355 103.974 366.26 102.019 367.946Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.894 123.732C147.829 123.801 147.971 123.214 148.034 122.511C148.065 121.731 147.941 121.096 146.927 121.11C146.087 121.122 145.502 121.508 145.454 122.317C145.402 123.218 145.977 123.664 146.894 123.732Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9634 193.116C74.6896 193.209 74.6876 192.407 74.7306 191.7C74.7772 190.943 74.4935 190.452 73.6162 190.468C72.7752 190.482 72.1957 190.873 72.1487 191.683C72.0963 192.592 72.6963 193.044 73.9634 193.116Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61 230.909C51.5161 230.988 51.7295 230.449 51.7859 229.509C51.7975 228.962 51.7442 228.289 50.7061 228.286C49.8622 228.284 49.2732 228.659 49.2037 229.461C49.125 230.365 49.6976 230.829 50.61 230.909Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8218 169.01C94.5689 169.132 94.6649 168.397 94.7038 167.653C94.7421 166.927 94.5597 166.367 93.65 166.365C92.7339 166.363 92.1232 166.771 92.1179 167.678C92.1125 168.492 92.6825 168.933 93.8218 169.01Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.456 112.991C164.449 113.119 164.681 112.535 164.743 111.337C164.789 110.899 164.545 110.344 163.572 110.371C162.734 110.394 162.171 110.802 162.135 111.619C162.1 112.434 162.624 112.884 163.456 112.991Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1936 309.434C18.9394 309.497 19.4638 309.039 19.5285 308.302C19.5943 307.557 19.1332 307.034 18.3958 306.967C17.6471 306.899 17.2085 307.378 17.0297 308.109C17.0838 308.839 17.4509 309.371 18.1936 309.434Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.894 102.453C180.651 102.57 181.153 102.127 181.29 101.406C181.438 100.628 180.974 100.127 180.248 100.074C179.548 100.023 179.063 100.47 178.863 101.284C178.917 101.84 179.232 102.349 179.894 102.453Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3644 282.307C25.121 282.424 25.6233 281.981 25.7601 281.26C25.9081 280.482 25.4444 279.981 24.7193 279.928C24.018 279.877 23.5329 280.324 23.3337 281.138C23.3866 281.694 23.7016 282.203 24.3644 282.307Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4556 296.028C22.2053 296.1 22.7035 295.644 22.7911 294.905C22.8833 294.129 22.4297 293.638 21.6778 293.637C20.9749 293.636 20.5182 294.099 20.3668 294.811C20.4263 295.489 20.7969 295.965 21.4556 296.028Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7725 217.12C54.5419 217 55.0031 216.567 54.999 215.821C54.995 215.154 54.5824 214.664 53.8917 214.697C53.1235 214.733 52.5567 215.195 52.5979 216.017C52.6312 216.685 53.132 217.041 53.7725 217.12Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.858 134.007C130.618 134.132 131.118 133.69 131.261 132.973C131.416 132.197 130.954 131.691 130.232 131.631C129.532 131.573 129.042 132.019 128.835 132.841C128.889 133.383 129.191 133.897 129.858 134.007Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3323 323.119C16.025 323.19 16.4426 322.737 16.5359 322.072C16.6446 321.294 16.227 320.771 15.4852 320.721C14.7802 320.672 14.2883 321.116 14.1173 321.857C14.1992 322.566 14.6223 323.045 15.3323 323.119Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3067 336.828C13.0058 336.931 13.441 336.496 13.5554 335.835C13.6869 335.075 13.3118 334.512 12.562 334.432C11.8574 334.358 11.3507 334.786 11.1374 335.575C11.2253 336.206 11.5922 336.724 12.3067 336.828Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23542 350.562C9.79786 350.402 10.2674 350.085 10.2685 349.367C10.269 348.6 9.87539 348.087 9.0975 348.124C8.39158 348.158 7.82639 348.63 7.86148 349.355C7.89348 350.056 8.44083 350.467 9.23542 350.562Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.856 179.082C77.5561 179.109 78.0202 178.923 78.0527 178.128C78.0864 177.324 77.6204 177.093 76.928 177.093C76.2202 177.015 75.77 177.252 75.7366 178.039C75.7031 178.834 76.1568 179.055 76.856 179.082Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.212 144.554C113.937 144.58 114.353 144.334 114.37 143.558C114.387 142.737 113.87 142.595 113.205 142.553C112.469 142.506 112.066 142.787 112.045 143.756C112.038 144.347 112.527 144.529 113.212 144.554Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9128 254.716C31.5854 254.739 32.1004 254.628 32.1552 253.813C32.2077 253.031 31.7982 252.767 31.0834 252.723C30.3935 252.682 29.9003 252.833 29.8549 253.435C29.7905 254.393 30.1835 254.69 30.9128 254.716Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4064 154.934C96.9984 154.972 97.3104 154.68 97.3499 154.092C97.3905 153.485 97.2572 153.007 96.5087 152.982C95.8879 152.972 95.4456 153.255 95.4111 153.899C95.376 154.537 95.7655 154.891 96.4064 154.934Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.753 109.682C150.474 109.716 150.674 109.275 150.688 108.658C150.702 108.069 150.424 107.75 149.831 107.727C149.181 107.702 148.834 108.042 148.712 108.659C148.785 109.288 149.105 109.652 149.753 109.682Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8 240.976C34.3738 241.027 34.7319 240.781 34.7809 240.178C34.8294 239.584 34.7273 239.089 33.9936 239.029C33.3471 238.976 32.9796 239.292 32.8193 239.903C32.8513 240.533 33.1536 240.919 33.8 240.976Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7488 203.151C57.5425 203.273 57.7034 202.78 57.7372 202.174C57.769 201.599 57.5216 201.246 56.9181 201.211C56.2761 201.173 55.846 201.474 55.7937 202.109C55.7401 202.753 56.1456 203.087 56.7488 203.151Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19742 363.382C6.59384 363.223 7.33186 363.81 7.40362 362.829C7.45974 362.052 7.07517 361.759 6.34462 361.719C5.65611 361.68 5.17797 361.815 5.09121 362.622C4.98689 363.587 5.70595 363.274 6.19742 363.382Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7886 268.511C28.418 268.56 28.8442 268.231 28.9369 267.615C29.0395 266.931 28.7231 266.435 28.0113 266.344C27.3179 266.256 26.8834 266.605 26.7617 267.333C26.755 268.012 27.0741 268.454 27.7886 268.511Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1738 189.711C60.9706 189.841 60.8867 189.219 60.894 188.771C60.8999 188.377 60.9722 187.833 60.2538 187.93C59.7228 188.001 59.3261 188.216 59.1933 188.776C59.2763 189.346 59.6469 189.624 60.1738 189.711Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.453 120.065C133.859 120.113 133.858 119.606 133.884 119.198C133.909 118.796 133.999 118.245 133.377 118.225C132.806 118.206 132.229 118.429 132.212 119.103C132.197 119.667 132.672 119.918 133.453 120.065Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.658 99.2098C167.259 99.2242 167.232 98.6667 167.23 98.2553C167.229 97.8481 167.278 97.3302 166.602 97.4007C166.063 97.4666 165.57 97.6798 165.553 98.2487C165.532 98.9156 166.093 99.1956 166.658 99.2098Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.154 88.4504C183.861 88.6482 183.861 88.1012 183.902 87.7096C183.948 87.2664 184.107 86.6513 183.31 86.6725C182.779 86.6875 182.372 86.9248 182.212 87.499C182.269 88.055 182.637 88.3056 183.154 88.4504Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.461 130.747C117.153 130.913 117.155 130.379 117.19 129.984C117.229 129.538 117.379 128.926 116.575 128.969C116.042 128.997 115.643 129.236 115.497 129.804C115.57 130.366 115.94 130.622 116.461 130.747Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8999 165.269C80.5576 165.36 80.525 164.815 80.5553 164.417C80.5858 164.01 80.6315 163.53 80.1593 163.461C79.4846 163.501 78.9673 163.683 78.8887 164.23C78.7931 164.896 79.3138 165.189 79.8999 165.269Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3094 227.54C37.9537 227.613 37.9219 227.066 37.946 226.667C37.971 226.26 38.0223 225.771 37.5553 225.73C36.853 225.775 36.3448 225.967 36.2768 226.518C36.1958 227.189 36.7301 227.474 37.3094 227.54Z",
    fill: "#64A460",
    fillOpacity: 0.52
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopEventImage);
export default __webpack_public_path__ + "static/media/topEventImage.cc869b963de4f4055dc239d4b7b9b773.svg";
export { ForwardRef as ReactComponent };